import axios from "axios";
import { getApiBaseUrl } from "../../config";

const apiPrefixReports = getApiBaseUrl("reports");
const apiPrefixCoaster = getApiBaseUrl("coaster");

export const getUsageHeatmapData = async (req_body, authtoken) => {
  return await axios.post(
    `${apiPrefixReports}/api/v1/svc-smart-tag/sensor-motion-data`,
    req_body,
    {
      headers: {
        token: authtoken,
      },
    },
  );
};
